module.exports = __webpack_public_path__ + "media/components/src/assets/images/embellishments/book-details/book_detail_02-e33594594385af204679fa3012bf5fd5.png";